import Vue from 'vue';
import Waveforms from '@/resources/waveforms';
import RootStateCommit from '@/store/mixins/rootstate-commit';
import normalize from '@/lib/normalize';

const MODULE_NAME = 'waveform';

const DEFAULT_STATE = {
  waveformData: {},
  error: ''
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    parseResponseData(state, response) {
      const norm = normalize(response);
      Vue.set(state, 'waveformData', norm);
    },
    setResponseError(state, response) {
      let errorMessage = 'Something went wrong.';
      if (response.status === 404) {
        errorMessage = 'There are no measurements for selected date.';
      }
      state.error = errorMessage;
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    }
  },
  actions: {
    fetchData({ commit }, { id }) {
      const action = Waveforms.get({ id, format: 'json' });

      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      action.then(
        response => {
          commit('parseResponseData', response.data);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        },
        response => {
          commit('setResponseError', response);
          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
        }
      );

      return action;
    }
  }
};
